Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSizing = void 0;
var _react = require("react");
var _useBreakpoints2 = require("./useBreakpoints");
var _ConfigurationContext = require("../../../utils/ConfigurationContext");
var useSizing = exports.useSizing = function useSizing() {
  var _topBarHeight$ClientA;
  var _useContext = (0, _react.useContext)(_ConfigurationContext.ConfigurationContext),
    ClientApplication = _useContext.ClientApplication;
  var _useBreakpoints = (0, _useBreakpoints2.useBreakpoints)(),
    bp = _useBreakpoints.bp;
  var _topBarHeight = {
    "default": 72
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    _topBarHeight["default"] = 144;
  }
  _topBarHeight.zero = 144;
  if (bp.is([bp.mobile_normal, bp.mobile_m, bp.mobile_l, bp.mobile_xl])) {
    _topBarHeight.zero = 168;
  }
  var sizing = {
    base: 16,
    headerPaddingBottom: 64,
    topBarHeight: (_topBarHeight$ClientA = _topBarHeight[ClientApplication]) != null ? _topBarHeight$ClientA : _topBarHeight["default"],
    topBarHeightDefault: _topBarHeight["default"]
  };
  return {
    sizing: sizing
  };
};